import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from '../data.service';

@Component({
  selector: 'app-archivo',
  template: '',
  styles: []
})  

export class ArchivoComponent implements OnInit{
  idencuesta;
  nombrearchivo;

  constructor(public data: DataService, private route: ActivatedRoute, private router: Router) {
    
  }

  ngOnInit(): void {
    // Obtener el nombre del archivo desde la URL
    this.idencuesta = this.route.snapshot.paramMap.get('idencuesta');
    this.nombrearchivo = this.route.snapshot.paramMap.get('nombrearchivo');
  
    if (this.idencuesta && this.nombrearchivo) {
      let ruta=this.idencuesta+"/"+this.nombrearchivo;
      this.data.downloadAndDisplayFile(ruta);
    }
  }



}


